/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
} from './Document';

/**
 * 
 * @export
 * @interface GetDocumentResponse
 */
export interface GetDocumentResponse {
    /**
     * 
     * @type {string}
     * @memberof GetDocumentResponse
     */
    message: string;
    /**
     * 
     * @type {Document}
     * @memberof GetDocumentResponse
     */
    document: Document;
}

/**
 * Check if a given object implements the GetDocumentResponse interface.
 */
export function instanceOfGetDocumentResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "document" in value;

    return isInstance;
}

export function GetDocumentResponseFromJSON(json: any): GetDocumentResponse {
    return GetDocumentResponseFromJSONTyped(json, false);
}

export function GetDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDocumentResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'document': DocumentFromJSON(json['document']),
    };
}

export function GetDocumentResponseToJSON(value?: GetDocumentResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'document': DocumentToJSON(value.document),
    };
}

